import React from "react";
import { IconButton, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { DotsThreeVertical, PencilSimple, ArrowsClockwise } from "@phosphor-icons/react";

// Per-supplier actions kebab. Edit opens the edit modal; Change status opens
// the status picker. Stop propagation so clicking the menu doesn't trigger any
// row/card click handler.
function SupplierActionsMenu({ onEdit, onChangeStatus }) {
  return (
    <Menu placement="bottom-end" isLazy>
      <MenuButton
        as={IconButton}
        aria-label="Supplier actions"
        icon={<DotsThreeVertical size={18} weight="bold" />}
        size="sm"
        variant="ghost"
        color="gray.500"
        _hover={{ bg: "gray.100" }}
        onClick={(e) => e.stopPropagation()}
      />
      <MenuList minW="180px" onClick={(e) => e.stopPropagation()}>
        <MenuItem icon={<PencilSimple size={15} />} fontSize="14px" onClick={onEdit}>
          Edit
        </MenuItem>
        <MenuItem icon={<ArrowsClockwise size={15} />} fontSize="14px" onClick={onChangeStatus}>
          Change status
        </MenuItem>
      </MenuList>
    </Menu>
  );
}

export default SupplierActionsMenu;
